import React, { useEffect, useState, useMemo } from "react";
import { Tabs, Tab, Box } from "@mui/material";
import { LatoInstallation } from "../components/forms/Pergola_type";
import { useStoreSelector } from "../../../../../../hooks/StoreHooks";
import { TubolariChoice } from "./tubolariChoice";

type Side = "front" | "left" | "right" | "back";

const SIDE_TO_DIREZIONE: Record<Side, string> = {
  front: "Fronte",
  left: "Sinistra",
  back: "Retro",
  right: "Destra",
};

const EsteticaChoices: React.FC = () => {
  const [side, setSide] = useState<Side>("front");
  const lati = useStoreSelector(
    (store) => store.pergolaConfigurationBuilder.configuration?.dimensioni.lati
  );

  const isAddossato = (direzione: string) =>
    lati?.some((l) => l.direzione === direzione && l.tipo === LatoInstallation.addossato);

  const availableSides = useMemo<Side[]>(() => {
    const all: Side[] = ["front", "left", "back", "right"];
    return all.filter((s) => !isAddossato(SIDE_TO_DIREZIONE[s]));
  }, [lati]);

  useEffect(() => {
    if (!availableSides.includes(side) && availableSides.length > 0) {
      setSide(availableSides[0]);
    }
  }, [availableSides, side]);

  const handleChange = (_: React.SyntheticEvent, newValue: Side) => {
    setSide(newValue);
  };
  const tabStyle = {
    flexDirection: "column",
    textTransform: "none",
    p: 1.5,
    minWidth: 80,
    border: "1px solid transparent",
    borderRadius: "8px 8px 0 0",
    bgcolor: "transparent",
    transition: "0.3s",
    "&.Mui-selected": {
      bgcolor: "background.paper",
      borderColor: "primary.main",
      borderBottom: "1px solid white",
    },
  };

  const boxStyles = {
    front: {
      width: 40,
      height: 40,
      border: "1px dashed #999",
      display: "flex",
      alignItems: "flex-end",
      justifyContent: "center",
      position: "relative",
      "& > div": { width: "80%", height: 4, bgcolor: "primary.main" },
    },
    left: {
      width: 40,
      height: 40,
      border: "1px dashed #999",
      display: "flex",
      alignItems: "center",
      justifyContent: "flex-start",
      "& > div": { width: 4, height: "80%", bgcolor: "primary.main" },
    },
    right: {
      width: 40,
      height: 40,
      border: "1px dashed #999",
      display: "flex",
      alignItems: "center",
      justifyContent: "flex-end",
      "& > div": { width: 4, height: "80%", bgcolor: "primary.main" },
    },
    back: {
      width: 40,
      height: 40,
      border: "1px dashed #999",
      display: "flex",
      alignItems: "flex-start",
      justifyContent: "center",
      position: "relative",
      "& > div": { width: "80%", height: 4, bgcolor: "primary.main" },
    },
  };
  
  const sidesMap: Record<Side, JSX.Element> = {
    front: <TubolariChoice lato="Fronte"/>,
    left: <TubolariChoice lato='Sinistra'/>,
    right: <TubolariChoice lato='Destra'/>,
    back: <TubolariChoice lato='Retro'/>,
  };

  const SIDE_LABELS: Record<Side, string> = { front: "A", left: "B", back: "C", right: "D" };

  return (
    <Box component="div">
      <Tabs
        value={availableSides.includes(side) ? side : availableSides[0] ?? "front"}
        onChange={handleChange}
        variant="scrollable"
        scrollButtons="auto"
        sx={{
          display: "flex",
          gap: 10,
          "& .MuiTabs-indicator": { display: "none" },
        }}
      >
        {availableSides.map((s) => (
          <Tab
            key={s}
            value={s}
            sx={tabStyle}
            icon={
              <Box sx={boxStyles[s]} component="div">
                <Box component="div" />
              </Box>
            }
            iconPosition="top"
            label={SIDE_LABELS[s]}
          />
        ))}
      </Tabs>
      <Box
        sx={{
          border: "1px solid",
          borderColor: "primary.main",
          borderRadius: 2,
          borderTopLeftRadius: 0,
          borderTopRightRadius: 0,
          p: 2,
          mt: "-1px",
        }}
        component="div"
      >
        {sidesMap[side]}
      </Box>
    </Box>
  );
};

export default EsteticaChoices;
